export const environment = {
  GRAPHQL_URI: 'https://agu-stage-app-mjapi.azurewebsites.net/graphql',
  GRAPHQL_WS_URI: 'wss://agu-stage-app-mjapi.azurewebsites.net/graphql',
  REDIRECT_URI: 'https://orange-sky-006a6bb0f.7.azurestaticapps.net/',
  CLIENT_ID: 'JcmiPxPYG6KRDsDLK4JfM4XPknj83Uxm',
  TENANT_ID: '0ef21773-0c23-471e-b615-9fdbdf1a47c7',
  CLIENT_AUTHORITY: 'dev-8lf6x8z0jn44hszt.us.auth0.com',
  AUTH_TYPE: 'forgerock' as const,
  NODE_ENV: 'production',
  AUTOSAVE_DEBOUNCE_MS: 1200,
  SEARCH_DEBOUNCE_MS: 800,
  MIN_SEARCH_LENGTH: 3,
  MJ_CORE_SCHEMA_NAME: '__mj',
  production: false,
  APPLICATION_NAME: 'CDP',
  APPLICATION_INSTANCE: 'STAGE',
  AUTH0_DOMAIN: 'dev-8lf6x8z0jn44hszt.us.auth0.com',
  AUTH0_CLIENTID: 'JcmiPxPYG6KRDsDLK4JfM4XPknj83Uxm',
  FORGEROCK_ISSUER: 'https://id.agu.org:443/am/oauth2',
  FORGEROCK_CLIENTID: 'BlueCypress',
  FORGEROCK_REDIRECT_URI: 'https://my-stage.agu.org',
  FORGEROCK_SCOPES: 'openid profile email',
  FORGEROCK_SERVICE: 'AuthAGU'
};
